import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { can } from "../../utils/can";

export default function Disclaimer() {
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const token = localStorage.getItem("adminToken");

  const [disclaimer, setDisclaimer] = useState("");      // CKEditor content
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Fetch existing Privacy Policy
  const fetchPolicy = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/admin/disclaimer-list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) {
        setDisclaimer(data.data?.[0]?.disclaimer || "");
      } else {
        setDisclaimer("");
      }
    } catch (err) {
      console.error("Fetch Policy Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, []);

  // Handle update
  const handleUpdate = async (e) => {
    if(can("disclaimer","edit") === false){
        alert("You don't have permission.");
        return;
      }

    e.preventDefault();
    setError("");
    setMessage("");

    if (!disclaimer.trim()) {
      setError("Privacy Policy content cannot be empty.");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/admin/disclaimer-create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ disclaimer }),
      });
      const data = await res.json();
      if (data.success) {
        setMessage("Disclaimer updated successfully!");
      } else {
        setError(data.message || "Failed to update Disclaimer.");
      }
    } catch (err) {
      console.error("Update Error:", err);
      setError("Server error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditorChange = useCallback((event, editor) => {
    setDisclaimer(editor.getData());
  }, []);

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Disclaimer" />

        <div className="right_col" role="main">
          

          {/* Privacy Policy Form */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Disclaimer Entry</h2>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <form onSubmit={handleUpdate}>
                <div className="row">
                  <div className="col-12 col-sm-12 pr-lg-0 mb-3">
                    <label>Add Disclaimer</label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={disclaimer}
                        onChange={(event, editor) => {
                          setDisclaimer(editor.getData());
                        }}
                        disabled={loading}
                      />


                    {error && <div style={{ color: "red", marginTop: "5px" }}>{error}</div>}
                    {message && <div style={{ color: "green", marginTop: "5px" }}>{message}</div>}
                  </div>

                  <div className="col-12" />
                  <div className="col-12 col-sm-12 pr-lg-0 text-right">
                    <button type="submit" className="btn sitebtn" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
